import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import AlLogisticPricingUpdate from '../AlLogisticPricingUpdate'
import AlLogisticPricingCopy from '../AlLogisticPricingCopy'

type Props = {
    id: number,
}

const AlLogisticPricingOverview = ({
    id,
}: Props) => {
    const {
        AlLogisticPricing: AlLogisticPricingRoutes,
    } = usePricingRoutes()

    return useSkyNetRoutes({
        routes: [
            {
                path: CommonRoutes.Slash,
                element: <AlLogisticPricingUpdate id={id} />,
            },
            {
                path: AlLogisticPricingRoutes.Copy.stringParams,
                element: <AlLogisticPricingCopy id={id} />,
            },
        ],
    })
}

export default AlLogisticPricingOverview
